module.exports = __webpack_public_path__ + "img/Group-1941.2d7fed5a.png";